<div id="toggler" class="row mx-0 my-1 pt-3 pb-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-11">
        <div class="row align-items-center">
            <div class="col-3 col-md-2 ps-0 d-flex flex-column align-items-center justify-content-center text-center">
                <div class="position-relative d-inline-block">
                    <fa-icon class="mb-2 d-block" [icon]="faBox" size="lg" aria-hidden="true"></fa-icon>
                    <span
                        class="badge rounded-pill status-pill-icon"
                        [ngClass]="statusIconClasses[smartlockerDelivery.Status]"
                    >
                        <fa-icon
                            [icon]="statusIcons[smartlockerDelivery.Status]"
                            size="xs"
                            aria-hidden="true"
                        ></fa-icon>
                    </span>
                </div>
                <div class="small">{{ smartlockerDelivery.Status }}</div>
            </div>

            <div class="col-6 fw-bold pe-0">
                <span [translate]="'SMARTLOCKER_AWB_LABEL'"></span>
                <span>{{ smartlockerDelivery.AWB }}</span>
            </div>
            <div class="col-3 ps-0">
                <span>{{ smartlockerDelivery.SmartlockerIdentifier }}</span>
            </div>
        </div>
    </div>
</div>
@if (!isCollapsed) {
    <div class="row ms-1 ms-md-2 ps-3 ps-md-5 me-0">
        @for (material of smartlockerDelivery.SmartlockerMaterials; track material.MaterialNumber) {
            <div class="col-12 smartlocker-materials-container mb-2 ps-0">
                <div class="row align-items-center material-row mx-0 py-2">
                    <div
                        class="col-3 offset-md-1 col-md-2 d-flex flex-column align-items-center justify-content-center text-center px-1 pt-3"
                    >
                        <div class="position-relative d-inline-block">
                            <fa-icon class="mb-2 d-block" [icon]="faCogs" aria-hidden="true"></fa-icon>
                            <span
                                class="badge rounded-pill status-pill-icon"
                                [ngClass]="material.Status ? statusIconClasses[material.Status] : 'bg-red'"
                            >
                                <fa-icon
                                    [icon]="material.Status ? statusIcons[material.Status] : faExclamation"
                                    size="xs"
                                    aria-hidden="true"
                                ></fa-icon>
                            </span>
                        </div>
                        <span class="small">{{ material.Status }}</span>
                    </div>

                    <div class="col-6 col-md-3 ps-3">
                        <div class="fw-bold">{{ material.ILPN }}</div>
                        <div>
                            <span [translate]="'SMARTLOCKER_MATERIAL_NO_LABEL'"></span>
                            {{ material.MaterialNumber }}
                        </div>
                        <div class="text-muted small">{{ material.Description }}</div>
                        <div class="text-muted small">Door Id {{ material.SmartlockerDoorId }}</div>
                    </div>
                    @if (
                        material.Status === SmartlockerDeliveryStatus.Delivered ||
                        material.Status === SmartlockerDeliveryStatus.InTransit
                    ) {
                        <div class="col-3 text-end">
                            <button
                                type="button"
                                class="btn btn-primary"
                                (click)="setSelectedDelivery(smartlockerDelivery); launchTransferModal(material)"
                                [translate]="'SMARTLOCKER_TRANSFER_BTN_LABEL'"
                            ></button>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
    @if (showTransferAllButton) {
        <div class="col-auto col-md-9 text-end py-3 pe-2">
            <button
                type="button"
                class="btn btn-primary"
                (click)="setSelectedDelivery(smartlockerDelivery); launchTransferModal()"
                [translate]="'SMARTLOCKER_TRANSFER_ALL_BTN_LABEL'"
            ></button>
        </div>
    }
}
